import React, { useEffect, useState } from 'react'
import { Tabs, Badge } from 'antd'
import Map from '../../containers/Dashboard/map/locationMap'
import DeviceMapTable from '../../containers/DeviceMap/deviceMapTable'
import DeviceMap from '../../containers/DeviceMap/deviceMap'
import TrackList from '../../containers/PublicTracking/trackList'
import axios from '../../util/Api'
import './index.css'

const { TabPane } = Tabs

const DashboardTabs = ({
    filterPayload,
    assets,
    orgModules,
    taggedDevices,
    getTaggedDeviceAssets,
    isLastDataProcessFinished,
    setDevicePositionalData,
    devicePositionalData
}) => {
    const [trackListCount, setTrackListCount] = useState(0)

    useEffect(() => {
        fetchTrackListCount()
    }, [])

    const fetchTrackListCount = async () => {
        try {
            const response = await axios.get('/live-track/asset-count')
            // console.log('response =>', response)
            if (response && response.data) {
                setTrackListCount(response.data.assetCount || 0)
                // console.log('trackListCount =>', response.data.assetCount)
            }
        } catch (err) {
            console.error('Error fetching track list count:', err)
        }
    }

    useEffect(() => {
        // console.log('filterPayload', filterPayload)
        // if(filterPayload) {
        //     getTaggedDeviceAssets(filterPayload)
        // }
        // @todo: get tagged devices assets

    }, [filterPayload])

    // console.log('trackListCount =>', trackListCount)

    return (
        <div className="gx-card">
            <div className="gx-card-body">
                <Tabs defaultActiveKey="1" type="card" className="dashboard-tabs">
                    <TabPane tab={'Location'} key="1">
                        <Map data={assets} />
                    </TabPane>
                    {orgModules && orgModules.includes('Telematics') &&
                        <TabPane tab={'Device-Map'} disabled={(!assets || !assets.length)} key="2">
                            <div className="dashboard-device-map-wrap">
                                <DeviceMap
                                    assets={assets}
                                    taggedDevices={taggedDevices}
                                    getTaggedDeviceAssets={getTaggedDeviceAssets}
                                    isLastDataProcessFinished={isLastDataProcessFinished}
                                    setDevicePositionalData={setDevicePositionalData}
                                />
                            </div>
                        </TabPane>
                    }
                    {orgModules && orgModules.includes('Telematics') &&
                        <TabPane
                            tab={'Device-Table'}
                            disabled={(!assets || !assets.length || !devicePositionalData.length || !isLastDataProcessFinished)}
                            key="3"
                        >
                            <DeviceMapTable
                                assets={assets}
                                taggedDevices={taggedDevices}
                                devicePositionalData={devicePositionalData}
                                isLastDataProcessFinished={isLastDataProcessFinished}
                            />
                        </TabPane>
                    }
                    {orgModules && orgModules.includes('Telematics') &&
                        <TabPane
                            tab={
                                <span>
                                    Public-Tracking
                                    {trackListCount > 0 && (
                                        <Badge
                                            count={trackListCount}
                                            style={{ marginLeft: 8, backgroundColor: '#52c41a' }}
                                        />
                                    )}
                                </span>
                            }
                            disabled={(!assets || !assets.length)}
                            key="4"
                        >
                            <TrackList />
                        </TabPane>
                    }
                </Tabs>
            </div>
        </div>
    )
}

export default DashboardTabs
